var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1360",
    "data-name": "Grupo 1360",
    transform: "translate(-4.072 -0.831)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_199",
    "data-name": "Rect\\xE1ngulo 199",
    width: 37,
    height: 35,
    transform: "translate(4.071 0.831)",
    fill: "#866509",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_626",
    "data-name": "Trazado 626",
    d: "M3.75-19.687v1.875h22.5v-1.875Zm0,7.5v1.875h22.5v-1.875Zm0,7.5v1.875h22.5V-4.687Z",
    transform: "translate(8.072 29.831)",
    fill: "#866509"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenu);
export default __webpack_public_path__ + "static/media/ic_menu.af166984230b553f39845fd9595d396b.svg";
export { ForwardRef as ReactComponent };